import React from "react";

export default function ServiceFeature({ feature }) {
    return (
        <div className="service-feature">
            <div className="service-feature-copy">
                <span>{feature.kicker}</span>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
                {feature.meta ? <small>{feature.meta}</small> : null}
            </div>
            {feature.image ? (
                <div className="service-feature-image">
                    <img src={feature.image} alt={feature.imageAlt || feature.title} />
                </div>
            ) : null}
        </div>
    );
}
